/*
 * nf-cep-shipping.js — calculadora de frete por CEP no carrinho (Fase 5).
 * -------------------------------------------------------------------
 * Delegacao de eventos em `document` (o snippet pode aparecer mais de uma
 * vez na mesma pagina — drawer + /cart). Guard contra carregamento duplo
 * porque o snippet inclui a propria tag <script> a cada instancia.
 *
 * GET /cart/shipping_rates.json?shipping_address[zip]={cep}&shipping_address[country]=Brazil
 * e endpoint legado do Shopify (funcional, sem SLA de doc) — qualquer erro
 * (CEP invalido, carrinho vazio, sem cobertura, endpoint fora do ar) cai
 * numa mensagem neutra. Nunca trava a compra.
 */
(function () {
  if (window.nfCepShippingLoaded) return;
  window.nfCepShippingLoaded = true;

  function onlyDigits(value) {
    return (value || '').replace(/\D/g, '');
  }

  /*
   * O endpoint /cart/shipping_rates.json exige shipping_address[province] (UF);
   * sem ele responde 422 "Selecione um estado". As faixas de CEP dos Correios
   * sao fixas e continuas (01000000-99999999), entao derivamos a UF do proprio
   * CEP, sem chamada externa. Lista ordenada pelo limite superior de cada faixa.
   */
  function cepToUf(cep) {
    var n = parseInt(cep, 10);
    if (Number.isNaN(n)) return '';
    var ranges = [
      [19999999, 'SP'], [28999999, 'RJ'], [29999999, 'ES'], [39999999, 'MG'],
      [48999999, 'BA'], [49999999, 'SE'], [56999999, 'PE'], [57999999, 'AL'],
      [58999999, 'PB'], [59999999, 'RN'], [63999999, 'CE'], [64999999, 'PI'],
      [65999999, 'MA'], [68899999, 'PA'], [68999999, 'AP'], [69299999, 'AM'],
      [69399999, 'RR'], [69899999, 'AM'], [69999999, 'AC'], [72799999, 'DF'],
      [72999999, 'GO'], [73699999, 'DF'], [76799999, 'GO'], [76999999, 'RO'],
      [77999999, 'TO'], [78899999, 'MT'], [78999999, 'RO'], [79999999, 'MS'],
      [87999999, 'PR'], [89999999, 'SC'], [99999999, 'RS']
    ];
    for (var i = 0; i < ranges.length; i++) {
      if (n <= ranges[i][0]) return ranges[i][1];
    }
    return '';
  }

  function maskCep(value) {
    var digits = onlyDigits(value).slice(0, 8);
    if (digits.length > 5) {
      return digits.slice(0, 5) + '-' + digits.slice(5);
    }
    return digits;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function formatMoney(amount, currency) {
    var value = Number(amount);
    if (Number.isNaN(value)) return escapeHtml(amount);
    try {
      return value.toLocaleString('pt-BR', { style: 'currency', currency: currency || 'BRL' });
    } catch (e) {
      return 'R$ ' + value.toFixed(2).replace('.', ',');
    }
  }

  function formatDeliveryRange(rate) {
    if (!rate.delivery_range || rate.delivery_range.length < 2) return '';
    try {
      var formatter = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit' });
      var min = formatter.format(new Date(rate.delivery_range[0]));
      var max = formatter.format(new Date(rate.delivery_range[1]));
      return 'Chegada estimada entre ' + min + ' e ' + max;
    } catch (e) {
      return '';
    }
  }

  function renderNeutralMessage(container, message) {
    container.innerHTML =
      '<p class="nf-cep-shipping__message nf-cep-shipping__message--neutral">' + escapeHtml(message) + '</p>';
  }

  /*
   * A entrega local nativa da Shopify vem com name/code fixos "Local Delivery"
   * (source "shopify") e nao pode ser renomeada no admin. Aqui ela recebe o texto
   * configurado no editor (settings.nf_local_delivery_label / _note). As demais
   * opcoes (Frenet, Correios etc.) passam intactas.
   */
  function isLocalDelivery(rate) {
    var code = String(rate.code || rate.name || '').toLowerCase();
    return String(rate.source || '').toLowerCase() === 'shopify' && code.indexOf('local delivery') !== -1;
  }

  function rateDisplay(rate, opts) {
    opts = opts || {};
    if (isLocalDelivery(rate)) {
      return {
        name: opts.localDeliveryLabel || 'Entrega local',
        eta: opts.localDeliveryNote || ''
      };
    }
    return {
      name: rate.name || rate.presentment_name || 'Frete',
      eta: formatDeliveryRange(rate)
    };
  }

  window.nfCepShippingHelpers = { rateDisplay: rateDisplay, isLocalDelivery: isLocalDelivery };

  function renderRates(container, rates, opts) {
    if (!rates || !rates.length) {
      renderNeutralMessage(container, 'Nenhuma opção de frete encontrada para este CEP. Calcule no checkout.');
      return;
    }

    var items = rates
      .map(function (rate) {
        var display = rateDisplay(rate, opts);
        var eta = display.eta;
        return (
          '<li class="nf-cep-shipping__rate">' +
          '<span class="nf-cep-shipping__rate-text">' +
          '<span class="nf-cep-shipping__rate-name">' +
          escapeHtml(display.name) +
          '</span>' +
          (eta ? '<span class="nf-cep-shipping__rate-eta">' + escapeHtml(eta) + '</span>' : '') +
          '</span>' +
          '<span class="nf-cep-shipping__rate-price">' +
          formatMoney(rate.price, rate.currency) +
          '</span>' +
          '</li>'
        );
      })
      .join('');

    container.innerHTML = '<ul class="nf-cep-shipping__rates" role="list">' + items + '</ul>';
  }

  function toggleLoading(button, isLoading) {
    if (!button) return;
    button.classList.toggle('loading', isLoading);
    if (isLoading) {
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-disabled');
    }
    var spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }

  function shippingRatesUrl() {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return base.replace(/\/$/, '') + '/shipping_rates.json';
  }

  function handleSubmit(form) {
    var wrapper = form.closest('[data-nf-cep-shipping]');
    if (!wrapper) return;

    var input = wrapper.querySelector('[data-nf-cep-input]');
    var button = wrapper.querySelector('[data-nf-cep-submit]');
    var result = wrapper.querySelector('[data-nf-cep-result]');
    if (!input || !result) return;

    var cep = onlyDigits(input.value);
    if (cep.length !== 8) {
      renderNeutralMessage(result, 'CEP inválido. Confira os números e tente novamente.');
      input.focus();
      return;
    }

    var displayOpts = {
      localDeliveryLabel: wrapper.getAttribute('data-nf-local-delivery-label') || '',
      localDeliveryNote: wrapper.getAttribute('data-nf-local-delivery-note') || ''
    };

    toggleLoading(button, true);
    renderNeutralMessage(result, 'Calculando frete…');

    var uf = cepToUf(cep);
    var params =
      '?shipping_address[zip]=' +
      encodeURIComponent(cep) +
      '&shipping_address[country]=Brazil';
    if (uf) {
      params += '&shipping_address[province]=' + encodeURIComponent(uf);
    }

    fetch(shippingRatesUrl() + params, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('nf-cep-shipping: request failed');
        return response.json();
      })
      .then(function (data) {
        if (!data || !data.shipping_rates) throw new Error('nf-cep-shipping: unexpected response shape');
        renderRates(result, data.shipping_rates, displayOpts);
      })
      .catch(function () {
        renderNeutralMessage(result, 'Não foi possível calcular o frete agora. Calcule no checkout.');
      })
      .finally(function () {
        toggleLoading(button, false);
      });
  }

  document.addEventListener('input', function (event) {
    var input = event.target.closest('[data-nf-cep-input]');
    if (!input) return;
    var caretAtEnd = input.selectionStart === input.value.length;
    input.value = maskCep(input.value);
    if (caretAtEnd) input.setSelectionRange(input.value.length, input.value.length);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-nf-cep-form]');
    if (!form) return;
    event.preventDefault();
    handleSubmit(form);
  });
})();
